export default __webpack_public_path__ + "static/media/027-baby.c4b6a6cb.svg";